import React, { Suspense } from "react";
import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import i18n from "oc/configs/i18n";
import { I18nextProvider } from "react-i18next";
import { ocLightTheme } from "oc/themes/oc-light-theme";
import { HashRouter } from "react-router-dom";
import { OcApolloContainer, OcLoading, OcSnackbar } from "oc/components";
import App from "./App";
import { RecoilRoot as GlobalState } from "recoil";
import { SnackbarProvider } from "notistack";

const AppRoot = () => {
  return (
    <GlobalState>
      <OcApolloContainer>
        <Suspense fallback={<OcLoading show={true} />}>
          <ThemeProvider theme={ocLightTheme}>
            <HashRouter>
              <SnackbarProvider>
                <OcSnackbar />
                <I18nextProvider i18n={i18n}>
                  <App />
                </I18nextProvider>
              </SnackbarProvider>
            </HashRouter>
          </ThemeProvider>
        </Suspense>
      </OcApolloContainer>
    </GlobalState>
  );
};

export default AppRoot;
